<p-dialog [(visible)]="display" [baseZIndex]="999999999999" [modal]="true" [draggable]=false (onHide)="onHide();"
  *ngIf="display" styleClass="centerScreen-dialog">
  <div class="popup-msg-container">
    <i [class]="icon" *ngIf="icon"></i>
    <img class="iconImage" [src]="iconImage" *ngIf="iconImage" [ngClass]="{'isGreyOut' : isGreyOut}" alt="icon-image"
      loading="lazy" />
    <div class="popup-msg-content">
      <p class="title" *ngIf="title">{{ title | translate }}</p>
      <p [innerHtml]="desc | translate" *ngIf="desc"></p>
    </div>

    <app-button [textButton]="!backgroundButton" [buttonName]="btn" (onClickEvent)="onHide()" class="action-btn"
      [ngClass]="{'backgroundButton': backgroundButton}" *ngIf="btn"></app-button>
  </div>
</p-dialog>